import { render } from "./SubmitOrder.vue?vue&type=template&id=4afb9104&scoped=true"
import script from "./SubmitOrder.vue?vue&type=script&lang=ts"
export * from "./SubmitOrder.vue?vue&type=script&lang=ts"

import "./SubmitOrder.vue?vue&type=style&index=0&id=4afb9104&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4afb9104"

export default script